import { render } from "./news.vue?vue&type=template&id=5e97ef74&scoped=true"
import script from "./news.vue?vue&type=script&lang=js"
export * from "./news.vue?vue&type=script&lang=js"

import "./news.vue?vue&type=style&index=0&id=5e97ef74&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5e97ef74"

export default script